import { render, staticRenderFns } from "./consumeList.vue?vue&type=template&id=07f5170d&"
import script from "./consumeList.vue?vue&type=script&lang=js&"
export * from "./consumeList.vue?vue&type=script&lang=js&"
import style0 from "./consumeList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports